import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { BreadcrumbItem, serializeBreadcrumbItems } from './breadcrumb.utils';

export type { BreadcrumbItem };

interface BreadcrumbContextType {
    breadcrumbs: BreadcrumbItem[];
    setBreadcrumbs: (items: BreadcrumbItem[]) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextType | undefined>(undefined);

export const BreadcrumbProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [breadcrumbs, setBreadcrumbsState] = useState<BreadcrumbItem[]>([]);

    const setBreadcrumbs = useCallback((items: BreadcrumbItem[]) => {
        setBreadcrumbsState((prev) => {
            if (serializeBreadcrumbItems(prev) === serializeBreadcrumbItems(items)) {
                return prev;
            }
            return items;
        });
    }, []);

    const value = useMemo(
        () => ({ breadcrumbs, setBreadcrumbs }),
        [breadcrumbs, setBreadcrumbs]
    );

    return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>;
};

export const useBreadcrumb = () => {
    const context = useContext(BreadcrumbContext);
    if (!context) {
        throw new Error('useBreadcrumb must be used within BreadcrumbProvider');
    }
    return context;
};
